import { cn } from "@/lib/utils";
import type { LogLevel } from "@/lib/types";
import { LEVEL_TONE } from "@/lib/levels";

const BG: Record<LogLevel, string> = {
  TRACE: "bg-muted/60",
  DEBUG: "bg-muted/60",
  INFO: "bg-secondary",
  WARN: "bg-warning/15",
  ERROR: "bg-destructive/15",
  FATAL: "bg-destructive/25",
};

export function LevelBadge({ level }: { level: LogLevel }) {
  return (
    <span
      className={cn(
        "inline-flex h-5 w-[58px] items-center justify-center rounded text-[10px] font-medium uppercase tracking-wide tabular-nums",
        BG[level],
        LEVEL_TONE[level],
      )}
    >
      {level}
    </span>
  );
}
